export default __webpack_public_path__ + "static/media/sp500-.b77637e9.svg";